import { AxiosStatic, Canceler } from "axios";
import { Summary } from "../../containers/NewOrderContainer/types";

const getSummary = async (
  http: AxiosStatic,
  cancel: Canceler,
  setCancel: (c: Canceler) => void,
  currencyId: string | undefined,
  currencyAmount: number,
  companyId: string,
  isReturn: boolean,
  isFcaCurrency: string,
  setSummary: (v: Summary) => void
) => {
  if (currencyId && currencyAmount && companyId) {
    if (cancel) {
      cancel("Previous request cancelled");
    }

    try {
      const response: any = await http.get(
        `/api/currencies/${currencyId}/indicative-price?companyId=${companyId}&direction=${
          isReturn ? 1 : 0
        }&currencyAmount=${currencyAmount}&ts=` +
          new Date().getTime() +
          `&settlement=${isFcaCurrency === "1" ? 1 : 0}`,
        {
          params: {
            // currencyAmount
          },
          cancelToken: new http.CancelToken(function(c) {
            setCancel(c);
          })
        }
      );

      setSummary(response.data || ({} as Summary));
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // The order could not be priced
        setSummary({});
      } else {
        throw error;
      }
    }
  } else {
    setSummary({});
  }
};

export default getSummary;
